import { render } from "./CamsChildView.vue?vue&type=template&id=1ed6af6c&scoped=true"
import script from "./CamsChildView.vue?vue&type=script&lang=js"
export * from "./CamsChildView.vue?vue&type=script&lang=js"

import "./CamsChildView.vue?vue&type=style&index=0&id=1ed6af6c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1ed6af6c"

export default script